<main id="content" class="bg-white">
    <div class="bg-paws-header border-bottom content-header d-none">
        @if ( announcement != null ) {
            <h1 class="d-inline-flex pe-3 mb-0">{{ announcement.title }}</h1>
        }
    </div>
    <div class="bg-white content-body">
        @if ( state=='not_found' ) {
            <div class="backgroundMask text-center">
                <div class="alert alert-warning" role="alert">
                    <div class="h2">There was a problem loading this announcement</div>
                    <div class="mt-3 h5">{{ message }}</div>
<!--                    <div class="mtlg h5">This can happen if the URL is not correct. Check the <a [routerLink]="['/search']">Apps & Services</a> page.</div>-->
<!--                    <div class="mtlg h5">This could also be because you do not have permission to access this channel. You can contact <a href='{{ getItSupportSubmitLink() }}' target="_blank">IT Support</a> for help.</div>-->
                </div>
            </div>
        }
        @if ( announcement != null ) {
            <ng-container *ngTemplateOutlet="timelineitem;context:{item:announcement}"></ng-container>
        }
    </div>
</main>


<ng-template #timelineitem let-item="item">
    <article class="border-bottom px-3 px-md-4 py-3"
             data-cy="timeline-data"
             [attr.data-announcementid]="item.id"
             [class.newsItem]="isNews(item)"
             [class.bulletin]="isBulletin(item)"
             [class.announcement]="isAnnouncement(item)"
             [class.featured]="isUSaskFeatured(item)"
             [class.mb-3]="isSticky(item)"
             [class.alert]="isAlert(item)"
    >
                <div class="small text-muted">
                    @if ( isUSaskNotice(item) || isUSaskFeatured(item) || isSticky(item) ) {
                        @if ( isFromCentralComms( item ) ) {
                            <img src="/assets/img/uofs-crest.png" height="16" width="14" atl="University of Saskatchewan" class="me-2 d-inline-block" style="margin-top:-4px;" />
                            <span class="message-category usaskNotice text-primary">{{ item.sentBy | uppercase }}</span>
                        } @else {
                            <span class="message-category">{{ item.sentBy }}</span>
                        }
                    } @else if ( isAlert(item) ) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-triangle-fill text-danger" viewBox="0 0 16 16" style="width:16px;height:16px;margin-right: 10px;">
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                        </svg>
                        <span class="message-category text-danger">{{ item.category }}</span>
                    } @else {
                        <span class="message-category">{{ item.category }}</span>
                    }
                    <!--                <div class="article-thumb-wrapper" [ngStyle]="{ 'background-image':'url(' + item.thumb + ')' }"></div>-->
                </div>
                @if ( isSticky(item) ) {
                    <div class="message-title text-primary px-0 h3 mb-0">
                        {{ item.title }}
                    </div>
                    <p class="text-muted">
                        <time class="message-pubdate text-muted">{{ item.pubDate }}</time>
                    </p>
                } @else if ( isAlert(item) ) {
                    <div class="message-title px-0 mb-0" [class.h5]="!item.isSticky" [class.h3]="item.isSticky">
                        {{ item.title }}
                    </div>
                } @else {
                    <div class="message-title px-0 py-2 mb-0 h5">
                        {{ item.title }}
                    </div>
                }
                @if ( isUSaskFeatured(item) ) {
                    <div><span class="badge text-bg-warning">Featured</span></div>
                }

        <div class="message-body mt-2 pb-3" id="content_{{ item.id }}" [attr.aria-labelledby]="'heading_'+item.id" role="article">
            <div class="itemBodyWrapper" [innerHTML]="item.body"></div>
            @if ( isSticky(item) ) {
                @if ( showActionLink(item) ) {
                    <button class="btn btn-lg btn-primary me-2 mb-2" (click)="doStickyAction(item)">{{ item.actionLabel }}</button>
                }
                @if ( item.dismissLabel!='' ) {
                    <button data-cy="sticky-dismiss" class="btn btn-lg btn-outline-secondary mb-2" (click)="doStickyDissmiss(item)">{{ item.dismissLabel }}</button>
                }
            }
            @if ( !isSticky(item) && item.sentBy!='' ){
                <hr />
                <p><span class="text-muted">Posted <time class="message-pubdate text-muted">{{ item.pubDate }}</time> by:</span><br> {{ item.sentBy }} </p>
            }
            @if ( item.attachment != '' ) {
                <p [innerHTML]="item.attachment"></p>
            }

        </div>

        <div class="clearfix"></div>
    </article>
</ng-template>
